module.exports = __webpack_public_path__ + "static/media/services-img4.d1090556.svg";